import _ from "lodash";
import { setTenancyId, getItemAnon } from "utils/localStorage";
import {setIsDemo} from "utils/clients";

interface Account {
    accountPublicId: string
    accountName: string
    userRole: string
    accountSerial: string
    isGov?: boolean
}

interface TenancyState {
    accountStatus: string
    selectedAccount?: Account
    selectedAccountId?: string
    accounts?: Account[]
    isDemo: boolean
    isGovAccount?: boolean
}

const defaultState: () => TenancyState = () => ({
    accountStatus: "PENDING",
    isDemo: false
});

const demoAccounts = _.chain(import.meta.env.VITE_TENANCY_DEMO_ACCOUNTS).split(";").map(_.trim).reject(_.isEmpty).value();

export default (state = defaultState(), { type, payload }: any): TenancyState => {
    switch (type) {
        case "TENANCY/LOAD-ACCOUNTS:SUCCESS": {
            const { selectedAccountId, accounts, isDemoMode } = payload;
            const selectedAccount = _.find(accounts, { accountPublicId: selectedAccountId });
            const isGovAccount = selectedAccount?.isGov ?? false;
            const isIntegratedMFE = import.meta.env.VITE_IS_APP_INTEGRATED_MFE;
            const isIframe = window.top !== window;
            const loadedUnderBXP = isIntegratedMFE || isIframe; // remove iframe once shell is fully integrated as shadow dom

            const isDemo = loadedUnderBXP ? isDemoMode : _.includes(demoAccounts, selectedAccountId) || getItemAnon({ itemKey: `feature.demo-mode` });

            setTenancyId({ tenancyId: selectedAccountId });

            if(isDemo) {
                setIsDemo();
            }

            return {
                ...state,
                accountStatus: "SUCCESS",
                isDemo,
                isGovAccount,
                selectedAccountId,
                selectedAccount,
                accounts
            }
        }
        case "TENANCY/LOAD-FAILED": {
            return {
                ...state,
                accountStatus: "FAILED"
            }
        }
        default: {
            return state;
        }
    }
};
